import React from "react";
import img from "../../../Assets/choose-us/choose-us.png";
import list from "../../../Assets/choose-us/list.png";
import { HiOutlineChevronRight } from "react-icons/hi";
import icon1 from "../../../Assets/choose-us/feature-icon-1.png";
import icon2 from "../../../Assets/choose-us/feature-icon-2.png";
import icon3 from "../../../Assets/choose-us/feature-icon-3.png";
import icon4 from "../../../Assets/choose-us/feature-icon-4.png";

const listData = [
  { icon: list, name: "Enhance soil health naturally" },
  { icon: list, name: "Improve yield with efficiency" },
  { icon: list, name: "Avoid damage that reduces productivity" },
];

const feautreData = [
  {
    img: icon1,
    name: "Crop Nutrition Solutions",
    description:
      "Delivers essential nutrients for stronger and healthier crops.",
  },
  {
    img: icon2,
    name: "Soil Enrichment Care",
    description: "Promotes lush growth with balanced and organic fertilizers.",
  },
  {
    img: icon3,
    name: "Advanced Fertigation",
    description:
      "Ensures efficient nutrient delivery through water soluble fertilizers.",
  },
  {
    img: icon4,
    name: "Sustainable Growth",
    description:
      "Enhances soil fertility for sustainable plant and tree growth.",
  },
];

const PeopleChooseUs = () => {
  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-yellow-50/30">
      <img src={img} alt="image" className="w-full object-cover" />
      <div className="flex flex-col md:flex-row w-full gap-4 rounded-2xl mt-12">
        <div className="flex flex-col md:w-[40%] items-start">
          <p className="text-[#92AD36] text-sm font-semibold tracking-wide mt-5">
            WHAT WE OFFER
          </p>
          <h2 className="text-2xl md:text-4xl font-serif text-[#232323] mt-4">
            Independently owned & operated
          </h2>
          <div className="flex mt-4 gap-2">
            <span className="w-10 h-1 bg-[#92AD36] "></span>
            <span className="w-3 h-1 bg-[#92AD36]"></span>
            <span className="w-5 h-1 bg-[#92AD36]"></span>
          </div>
          <p className="text-base text-[#8B8B8B] mt-4">
            We provide fertilizer solutions to farmers and agriculture
            businesses for better crop growth.
          </p>
          <div className="flex flex-col gap-2 mt-8 w-full">
            {listData.map((item, index) => (
              <div key={index} className="flex flex-col text-[#232323] w-full">
                <div className="flex gap-5">
                  <img src={item.icon} alt="" />
                  <span className="line-clamp-1">{item.name}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-2 mt-8">
            <span className="text-[#232323] text-base font-semibold">
              Learn More
            </span>
            <span>
              <HiOutlineChevronRight className="mt-1" />
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
          {feautreData.map((item, index) => (
            <div
              key={index}
              className="flex flex-col p-4 bg-white rounded-2xl items-start gap-4"
            >
              <div className="flex gap-3">
                <img
                  src={item.img}
                  alt=""
                  className="w-12 h-12 object-contain mt-3"
                />

                <div className="flex-col">
                  <h3 className="text-base font-semibold text-[#232323] ">
                    {item.name}
                  </h3>
                  <p className="text-sm text-[#8B8B8B] mt-3">
                    {item.description}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 ml-14">
                <span className="text-[#92AD36] text-sm font-semibold">
                  Learn More
                </span>
                <span>
                  <HiOutlineChevronRight className="text-[#92AD36] mt-0.5" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PeopleChooseUs;
